import type { TFunction } from "i18next";

export const getBoolName = (t: TFunction, value: string | boolean): string => {
  const boolValue = typeof value === 'string' ? value === 'true' : value;
  return boolValue ? t('innerLayout.common.yes') : t('innerLayout.common.no');
};